import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaAward } from "react-icons/fa6";
import EmployeeRewards from "./index";
import { MODULE_MY_AWARDS } from "variables/constants";

const myAwardRoutes = [	
    generateCRUDRoutes({
        mainTitle: "My Awards",
        basePath: "employee-awards",
        mainComponent: <EmployeeRewards />,
        layout: "/console",	   
        icon: <FaAward className="icon-item" />,
        subTitle:"Employee Award",
        level:5,
        moduleId: MODULE_MY_AWARDS,
    })
]

export default myAwardRoutes;